import WindowManager from './window-manager';
import EventBus from './eventbus';
export * from './window-manager/WindowMessage';
export * from './websocket';

WindowManager.init();

export { WindowManager, EventBus };
